import { create } from 'zustand'

/**
 * How tall the navigation is, as measured, so the tab screens can start their content beneath
 * it. The bar floats over the scene as glass, so the scene itself never knows where it ends.
 */
export const useNavBarHeight = create<{ height: number; setHeight: (h: number) => void }>(
	(set) => ({
		height: 0,
		setHeight: (height) => set({ height }),
	})
)
